import { useTranslation } from 'react-i18next';
import SocialMedia from '@components/social-media/SocialMedia';



const NotFoundPage = () => {
	const { t } = useTranslation('global');

	return (
		<div className="app-page not-found-page">
			
			<h1>{t('pages.notFoundHeader')}</h1>

			<div className='info-text'>
				<p>{t('pages.notFoundText')}</p>
			</div>

			<SocialMedia />

		</div>
	);
};

export default NotFoundPage;